import axios from "axios";
import * as url from "../helpers/url_helper"
const {REACT_APP_API_PROXY_BASE_URL} = process.env;

const getSsoLogin = (login, password, numeroCgos, exercice) => {
    return axios.get(REACT_APP_API_PROXY_BASE_URL + url.POST_SSO_LOGIN + "?username="+login+"&password="+password)
        .then((response) => {
            localStorage.setItem("authUser", JSON.stringify(response.data));
            localStorage.setItem("numeroCgos", numeroCgos);
            localStorage.setItem("exercice", exercice);
            window.location.href = '/dod';
        },
        (error) => {
            window.location.href = '/login';
        });
};

export default {
    getSsoLogin
};
